"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtraSmallAnchor = exports.SmallAnchor = exports.Anchor = exports.InlineAnchor = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AnchorBase = _interopRequireDefault(require("./AnchorBase"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.032em; /* .32 px */\n  line-height: 1.2; /* 12px */\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.3rem;\n  font-weight: 400;\n  letter-spacing: 0.025em; /* .325 px */\n  line-height: 1.64; /* 21.32px */\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.5rem;\n  font-weight: 400;\n  letter-spacing: 0.022em; /* .33px */\n  line-height: 1.54; /* 23.1px */\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: inherit;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * This component will pick up the color, size, and weight of the text surrounding it.
 * These values are explicitly inherited in case the global styles are changed
 */
var InlineAnchor = (0, _styledComponents.default)(_AnchorBase.default)(_templateObject());
/**
 * The Anchor, SmallAnchor, and ExtraSmallAnchor components can be used when they are not inline with other text or if an inline link needs different styling from its surrounding text.
 * These components are intended to both save dev time and support accessibility by pre-calculating the responsive line-height and letter-spacing values.
 * Their base styles are built off the onboarding Typography and footer link styles in the Figma spec file: https://www.figma.com/file/ypoEgXVpq5rM51vRq7b8QX/Figure-Application?node-id=1191%3A7937.
 * Dashboard Typography styles have not been updated in Figma yet.
 */

exports.InlineAnchor = InlineAnchor;
var Anchor = (0, _styledComponents.default)(_AnchorBase.default)(_templateObject2());
exports.Anchor = Anchor;
var SmallAnchor = (0, _styledComponents.default)(_AnchorBase.default)(_templateObject3());
/**
 * Design would like text to be at least 13px in order to improve legibility.
 * Footer links are currently the only exception at 10px.
 */

exports.SmallAnchor = SmallAnchor;
var ExtraSmallAnchor = (0, _styledComponents.default)(_AnchorBase.default)(_templateObject4());
exports.ExtraSmallAnchor = ExtraSmallAnchor;